/**
 * @file 倒计时 hook（短信冷却、重发按钮）
 * 为什么单独抽：登录页与后续绑定手机等场景都要用，且必须尊重 smsCooldownUntil 这个绝对时间戳，
 * 不能用「剩余秒数自减」——标签页切后台时定时器会被节流，相对计时会漂移。
 */

import { useEffect, useState } from 'react';

/**
 * @what 计算距离目标时间戳还剩多少秒（向上取整），每秒钟刷新
 * @param untilMs 目标时间戳（epoch ms），<= now 时返回 0
 * @return number 剩余秒数
 */
export function useCountdown(untilMs: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (untilMs <= Date.now()) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [untilMs]);

  if (untilMs <= now) return 0;
  return Math.ceil((untilMs - now) / 1000);
}
